import React, { Component } from "react";
import { Route, Redirect, Switch, NavLink } from "react-router-dom";
//import { ToastContainer } from "react-toastify";
//import jwtDecode from "jwt-decode";

//import TryBar from "./components/fields/trybar.jsx";

import UserContext from "./../common/context/userContext.js";
import SideMenuContext from "./../common/context/sideMenuContext.js";

import { getSessionUser } from "./../common/services/sessionServices";
import {
  getUserMenues,
  getDynamicUserMenues,
  loadImage,
} from "./../common/services/uiService.jsx";

import Home from "./components/home";
import Login from "./components/Login.jsx";
import Logout from "./../common/components/logout";
//import ChangePassword from "./components/resetPassword.jsx";

import Register from "./../common/components/register";
import AboutUs from "./../common/components/about";

import Contact from "./../common/components/contact";
import NotFound from "./../common/components/notFound";
import NavBar from "./components/navbar";
import SideMobileMenu from "./../common/components/sideMobileMenu.jsx";

//import MainHeader from "./components/mainHeader";
import ErrorPopupForm from "./../common/components/forms/errorPopupForm";
//import SideBar from "./components/fields/sidebar.jsx";

import { getlandRegistarReceipt_try } from "./../common/services/reportService.jsx";
//import config from "./config";
import "./../App.css";
import "bootstrap/dist/css/bootstrap.css";
import "font-awesome/css/font-awesome.css";
// import "jquery/dist/jquery";
import "bootstrap/dist/js/bootstrap.bundle.js";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { getSessionId } from "./../common/services/browserSessionID";
import ProcessContext from "./../common/context/processContext.js";
import { ToastContainer } from "react-toastify";
import { AuthProvider, useAuth, withAuth } from "./contexts/AuthContext.js";
import { configureApiClient, setAuthContextRef } from "./services/apiClient.js";
//import "bootstrap/dist/css/bootstrap.css";

// import "react-toastify/dist/ReactToastify.css";

//import logo1 from "./components/images/logo_Mapi.png";
// import logo2 from "./components/images/logo_Mapi@2x.png";
// import logo3 from "./components/images/logo_Mapi@3x.png";

//const apiEndPoint = "https://jsonplaceholder.typicode.com/posts";
//import MyAccount from "./components/myaccount";
//import SideBar from "./components/fields/sidebar";
//import http from "./services/httpService";

// Wrapper component to connect auth context to API client
const AuthConnector = ({ children }) => {
  const authContext = useAuth();

  React.useEffect(() => {
    // Connect the auth context to the API client
    setAuthContextRef(authContext);
  }, [authContext]);

  return children;
};

class MapiApp extends Component {
  static contextType = UserContext;
  showError = "ShowError";
  NotShowError = "NotShowError";
  warnTimeout = 0;
  warnTimeoutCallback = null;
  logoutTimeout = 0;
  logoutTimeoutCallback = null;

  state = {
    user: null,
    ownerProperties: [],
    ownerDemandNotices: [],
    ownerApplications: [],
    isAuthenticated: false,
    initialToggle: false,
    PropertyInitialToggle: false,
    PropertyInitialClassName: "CloseSectionDiv",

    isListOpen: false,
    isDropdownOpen: false,
    menuOpen: false,
    menues: [],
    errors: [],
    logginStatus: true,
    errorTitle: "",
    errorMessage: "",
    errorLinkTo: "",
    errorLinkTitle: "",
    errorLinkClassName: "",
    windowCmd: "",
    show: this.NotShowError,
    pdfUrl: null,
    isofflien: false,
    browserSessionID: getSessionId(),
    isSelectedMenu: '',
    processBackUp: [],
    activeTabData: []
  };

  constructor(props) {
    super(props);

    this.events = ["mousemove", "mousedown", "click", "scroll", "keypress"];

    this.warn = this.warn.bind(this);
    this.logout = this.logout.bind(this);
    this.resetTimeout = this.resetTimeout.bind(this);

    this.handleCurrentUser = this.handleCurrentUser.bind(this);
    this.handleOwnerProperties = this.handleOwnerProperties.bind(this);
    this.handleOwnerDemandNotices = this.handleOwnerDemandNotices.bind(this);
    this.handleOwnerApplications = this.handleOwnerApplications.bind(this);
    this.setSelectedMenu = this.setSelectedMenu.bind(this);
    this.setActiveTabData = this.setActiveTabData.bind(this);
    this.OpenMenuEvent = this.OpenMenuEvent.bind(this);
    this.closeHelp = this.closeHelp.bind(this);
    this.toggleDropdown = this.toggleDropdown.bind(this);
    this.toggleList = this.toggleList.bind(this);
    this.setProcessBackUp = this.setProcessBackUp.bind(this);
    /*window.screen.orientation.addEventListener('change', function ()
    {
      alert('orientation change');
      
      var lockOrientation = window.screen.lockOrientation || window.screen.mozLockOrientation || window.screen.msLockOrientation;
      alert('lockOrientation: ' + lockOrientation);

      if (window.innerHeight > window.innerWidth)
      {
        alert('(window.innerHeight > window.innerWidth');
        try{
          if (document.documentElement.requestFullscreen) {
            document.documentElement.requestFullscreen();
          } else if (document.documentElement.mozRequestFullScreen) {
            document.documentElement.mozRequestFullScreen();
          } else if (document.documentElement.webkitRequestFullscreen) {
            document.documentElement.webkitRequestFullscreen();
          } else if (document.documentElement.msRequestFullscreen) {
            document.documentElement.msRequestFullscreen();
          }

          if(window.screen !== undefined)
          {
            alert('window.screen.orientation: ' + window.screen.orientation.type);
            window.screen.orientation.lock('portrait');

            var lockOrientation = window.screen.lockOrientation || window.screen.mozLockOrientation || window.screen.msLockOrientation;
            alert('after lock lockOrientation: ' + lockOrientation);
            //document.getElementsByTagName('body')[0].style.transform = "rotate(90deg)";
          }
        }
        catch(e)
        {
          alert(e)
        }
          //
      }
    });*/

    for (var i in this.events) {
      window.addEventListener(this.events[i], this.resetTimeout);
    }
    const user = getSessionUser();
    if (user) {
      this.setTimeoutUser();
    }
  }

  setSelectedMenu = (payload) => {
    this.setState({
      isSelectedMenu: payload
    })
  }

  setActiveTabData = (payload) => {
    this.setState({
      activeTabData: payload
    })
  }

  clearTimeoutUser() {
    if (this.warnTimeoutCallback) clearTimeout(this.warnTimeoutCallback);

    if (this.logoutTimeoutCallback) clearTimeout(this.logoutTimeoutCallback);
  }

  setTimeoutUser() {
    let timeoutInSeconds = sessionStorage.getItem("TimeoutInSeconds");
    //let timeoutInSeconds = 30;
    if (timeoutInSeconds != null) {
      this.warnTimeout = timeoutInSeconds - 15;
      this.warnTimeoutCallback = setTimeout(this.warn, this.warnTimeout * 1000);
      this.logoutTimeoutCallback = setTimeout(
        this.logout,
        timeoutInSeconds * 1000
      );
    }
  }

  resetTimeout() {
    const user = getSessionUser();
    if (user) {
      this.clearTimeoutUser();
      this.setTimeoutUser();
    }
  }

  warn() {
    //var message = "You will be logged out automatically in 15 seconds.";
    //this.updateErrorMessage("Thank you", message,'','','','showLogoutButton;showContinueSessionButton');
    //this.updateShowCase(this.showError);
  }

  logout() {
    // Send a logout request to the API
    this.setState({ logginStatus: false });
    sessionStorage.clear();
    this.destroy(); // Cleanup
    window.location.href = window.location.origin + "/home";
  }

  destroy() {
    this.clearTimeoutUser();

    for (var i in this.events) {
      window.removeEventListener(this.events[i], this.resetTimeout);
    }
  }

  updateShowCase = (showStage) => {
    this.setState((currentState) => {
      return { show: showStage };
    });
  };

  updateErrorMessage = (
    title,
    message,
    linkTo = "",
    linkTitle = "",
    linkClass = "",
    cmd = ""
  ) => {
    this.setState({
      errorTitle: title,
      errorMessage: message,
      errorLinkTo: linkTo,
      errorLinkTitle: linkTitle,
      errorLinkClassName: linkClass,
      windowCmd: cmd,
    });
  };

  handleSideMenu = async () => {
    try {
      const result = await getDynamicUserMenues(this.props.generalEndPoint,
        this.state.user ? this.state.user.id : 0
      );
      this.setState({ menues: result });
    } catch (ex) {
      if (ex.response && ex.response.status === 400) {
        const errors = { ...this.state.errors };
        this.setState({ errors });
      }
    }
  };

  handleCurrentUser = async () => {
    const user = getSessionUser();

    if (user) {
      this.setState({
        user: user,
        isAuthenticated: true,
        initialToggle: false,
      });
    }
  };

  handleOwnerProperties = async (ownerProperties) => {
    this.setState({ ownerProperties: ownerProperties });
  };

  handleOwnerDemandNotices = async (ownerDemandNotices) => {
    this.setState({ ownerDemandNotices: ownerDemandNotices });
  };

  handleOwnerApplications = async (ownerApplications) => {
    this.setState({ ownerApplications: ownerApplications });
  };

  toggleDropdown() {
    this.setState((prevState) => ({
      isDropdownOpen: !prevState.isDropdownOpen,
    }));
  }

  handleMenuClick = (item) => {
    this.setState({ isListOpen: false });
  };

  toggleList1() {
    this.setState((prevState) => ({
      isListOpen: !prevState.isListOpen,
    }));
  }

  toggleList(event) {
    event.stopPropagation();

    this.setState((prevState) => ({
      isListOpen: !prevState.isListOpen,
    }));
  }

   handleCloseLogin = () => {
    // Handle login form close if needed
  };

  componentDidMount() {
    this.setState({ browserSessionID: getSessionId() });
    //Adapt scale for ios
    //const sessID = getSessionID();
    configureApiClient(this.props.generalEndPoint);

    const addMaximumScaleToMetaViewport = () => {
      const el = document.querySelector("meta[name=viewport]");

      if (el !== null) {
        let content = el.getAttribute("content");
        let re = /maximum\-scale=[0-9\.]+/g;

        if (re.test(content)) {
          content = content.replace(re, "maximum-scale=1.0");
        } else {
          content = [content, "maximum-scale=1.0"].join(", ");
        }

        el.setAttribute("content", content);
      }
    };

    const disableIosTextFieldZoom = addMaximumScaleToMetaViewport;

    const checkIsIOS = () =>
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    if (checkIsIOS()) {
      disableIosTextFieldZoom();
    }

    try {
      ///This code part eliminate the browser's back button action
      /*const { history } = this.props;

      window.addEventListener("popstate", () => {
        history.go(1);
      });*/

      const user = getSessionUser();

      if (user) {
        this.setState({
          user: user,
          isAuthenticated: true,
        });
        window.location("/home/myaccount");
      } else {
        this.setState({
          user: null,
          isAuthenticated: false,
        });
        window.location("/home");
      }
    } catch (ex) {
      console.log("App did mount", ex);
    }
  }

  collapseMenu() {
    const nv = document.getElementsByClassName("navbar-collapse");
    // if (nv !== undefined){ console.log("Collapse");
    nv.collapse = "hide";
  }
  /*
  OpenMenuEvent(){
    var sideMenuDiv = document.getElementById('SideMenu');

    if(sideMenuDiv !== undefined)
    {
      sideMenuDiv.style.animationName = "pageAnimationSideBarMobile";
      //sideMenuDiv.style.animationDuration = "0.75s";
    }
    this.setState({menuOpen:true});

  }*/

  OpenMenuEvent() {
    var sideMenuDiv = document.getElementById("SideMenu");

    if (sideMenuDiv !== undefined) {
      sideMenuDiv.style.animationName = "pageAnimationSideBarMobile";
      //sideMenuDiv.style.animationDuration = "0.75s";
    }
  }

  closeHelp() {
    var sideMenuDiv = document.getElementById("SideMenu");

    if (sideMenuDiv !== undefined) {
      sideMenuDiv.style.animationName = "pageAnimationSideBarMobileReverse";
      sideMenuDiv.style.animationDuration = "0.75s";
      //sideMenuDiv.style.animationName = "pageAnimationSideBarMobile";
    }
    this.setState({ menuOpen: false });
  }

  handleToggle = () => {
    const targetNav = document.getElementById("mainMenuNav");

    // Bootstrap's way of toggling dropdown
    if (targetNav.classList.contains("show")) {
      targetNav.classList.remove("show");
    } else {
      targetNav.classList.add("show");
    }
  };

  /*
  collapseMenu()
  {
  
      const nv = document.getElementsByClassName("navbar-collapse");
     // console.log("Collapse");
     // if (nv !== undefined){ console.log("Collapse");
       nv.collapse = "hide";

       this.setState({menuOpen:false});
  //}
  }*/

  toggleMenu() {
    const { menuOpen } = this.state;

    var sideMenuDiv = document.getElementById("SideMenu");
    if (menuOpen) {
      this.closeHelp();
    } else {
      this.OpenMenuEvent();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.isListOpen !== this.state.isListOpen) {
      // Force a re-render to ensure the correct rendering
      this.forceUpdate();
    }
  }

  fetchPdf = async () => {
    await getlandRegistarReceipt_try(this.props.reportsEndPoint, 0, 482, null);
  };

  setProcessBackUp = (payload) => {
    this.setState({
      processBackUp: payload
    })
  }

  render() {
    const logo1 = loadImage("logo_Mapi.png");

    return (
      <AuthProvider applicationName="Mapi">
      <AuthConnector>
      <SideMenuContext.Provider
        value={{
          menues: this.state.menues,
          isSelectedMenu: this.state?.isSelectedMenu,
          activeTabData: this.state.activeTabData,
          onHandleSideMenu: this.handleSideMenu,
          setSelectedMenu: this.setSelectedMenu,
          setActiveTabData: this.setActiveTabData
        }}
      >
        <UserContext.Provider
          value={{
            handleCurrentUser: this.handleCurrentUser,
            handleOwnerProperties: this.handleOwnerProperties,
            handleOwnerDemandNotices: this.handleOwnerDemandNotices,
            handleOwnerApplications: this.handleOwnerApplications,

            user: this.state.user,
            isAuthenticated: this.state.IsAuthenticated,
            SID: this.state.user ? this.state.user.sid : "",
            UID: this.state.user ? this.state.user.unique_name : "",
            FirstName: this.state.user ? this.state.user.given_name : "",
            LastName: this.state.user ? this.state.user.family_name : "",
            FullNameCompany: this.state.user ? this.state.user.gender : "",
            NID: this.state.user ? this.state.user.nameid : "",
            Email: this.state.user ? this.state.user.email : "",
            Mobile: this.state.user ? this.state.user.nonce : "",
            userName: this.state.user ? this.state.user.sub : "",
            Pwd: this.state.user ? this.state.user.prn : "",
            OwnerId: this.state.user ? this.state.user.actort : "",
            ownerProperties: this.state.ownerProperties,
            ownerDemandNotices: this.state.ownerDemandNotices,
            ownerApplications: this.state.ownerApplications,
            initialToggle: this.state.initialToggle,
            PropertyInitialToggle: this.state.PropertyInitialToggle,
            PropertyInitialToggleClass: this.state.PropertyInitialClassName,

            // OwnerId: this.state.user ? this.state.user.nbf : "",
          }}
        >
          <ProcessContext.Provider value={{
            processBackUp: this.state.processBackUp,
            setProcessBackUp: this.setProcessBackUp
          }}>
            <React.Fragment>
              <div className="inlineDiv">
                <div id="mainNavBar">
                  <NavBar/>
                </div>

                <div id="rightLogoDiv">
                  <a href="/home">
                    <img
                      src={logo1}
                      className="logo_Mapi"
                      srcSet={`${logo1} 1x, ${logo1} 2x, ${logo1} 3x`}
                      alt=""
                    />
                  </a>
                </div>

                <nav
                  id="rightMenu"
                  className="navbar navbar-expand-lg navbar-light"
                >
                  <button
                    id="MenuBtn"
                    className="navbar-toggler"
                    onClick={this.toggleList}
                  >
                    {this.state.isListOpen ? (
                      <span className="fas fa-times"></span>
                    ) : (
                      <span className="navbar-toggler-icon"></span>
                    )}
                  </button>
                </nav>
              </div>

              {/* <main data-toggle="collapse" data-target="#mainMenuNav"  aria-expanded="true"> */}
              <main id="main">
                <Switch>
                   <Route
                    path="/login"
                    render={() => (
                      <Login
                        closeLoginForm={this.handleCloseLogin}
                        applicationName="Mapi"
                      />
                    )}
                  />
                  <Route path="/home/login/:id?" render={(props) => <Login {...props} 
                  generalEndPoint={this.props.generalEndPoint} 
                  usersEndPoint = {this.props.usersEndPoint}
                  isMapi={true}/>} />
                  {/* <Route
                  path="/home/changePwd/:token?"
                  component={ChangePassword}
                /> */}
                
                  <Route path="/login/:id?" render={(props) => <Login {...props} 
                  generalEndPoint={this.props.generalEndPoint} 
                  usersEndPoint = {this.props.usersEndPoint}
                  isMapi={true}/>} />
                  
                  {/* <Route path="/login" component={Login} /> */}
                  <Route path="/logout" render={(props) => <Logout {...props} usersEndPoint={this.props.usersEndPoint}/>} />
                  <Route path="/register" component={Register} />
                  <Route path="/about" component={AboutUs} />
                  <Route path="/contact" component={Contact} />

                  {/* <Route path="/landRegister" exact component={LandRegister} />
                <Route path="/payments" exact component={Payments} />
                <Route path="applicationTrackinig" exact component={ApplicationTracking} /> */}
                  {/* <Route path="/home/myaccount/:id?" component={MyAccount} /> */}
                  {/* <Route path="/myaccount/:id?" render={(props) => <Logout {...props} 
                  reportsEndPoint={this.props.reportsEndPoint} 
                  searchEndPoint = {this.props.searchEndPoint}
                  usersEndPoint = {this.props.usersEndPoint}/>} />*/}

                  <Route path="/not-found" component={NotFound} />
                  <Route path="/home" render={(props) => <Home {...props} generalEndPoint={this.props.generalEndPoint} socketConnectionEndPoint={this.props.socketConnectionEndPoint}/>} />
                  
                  {/* <Redirect from="/changePwd" exact to="/home/changePwd" /> */}
                  <Redirect from="/" exact to="/home" />
                  <Redirect to="/not-found" />
                </Switch>

                <SideMobileMenu
                  showsideMobileMenu={this.state.isListOpen}
                  //updateVisibility={this.toggleList1}
                  handleClick={this.handleMenuClick}
                />
                {this.state.show === this.showError ? (
                  <div>
                    <ErrorPopupForm
                      errorTitle={this.state.errorTitle}
                      errorMessage={this.state.errorMessage}
                      errorLinkTo={this.state.errorLinkTo}
                      errorLinkTitle={this.state.errorLinkTitle}
                      errorLinkClassName={this.state.errorLinkClassName}
                      windowCmd={this.state.windowCmd}
                      logoutFunc={this.logout}
                    />
                  </div>
                ) : (
                  ""
                )}
              </main>
            </React.Fragment>
          </ProcessContext.Provider>
        </UserContext.Provider>
      </SideMenuContext.Provider>
      </AuthConnector>
     </AuthProvider>
    );
  }
}
MapiApp.contextType = UserContext;
export default MapiApp;
